import {
  getRelativeCoordinates,
  shiftByPageOffset,
  shiftByCenter,
  shiftUp,
} from "./helpers/coordinates-calculation"
import readBoundaries from "./helpers/read-boundaries"

import {
  create,
  append,
  remove,
  move,
  addArrowDown,
  getClosestScrollContainer,
  listenScroll,
  listenResize,
  listenMutations,
  listenLayoutUpdate,
} from "."
import "./expand-tooltip.scss"

class ExpandTooltip {
  constructor() {
    this.tooltip = null
    this.removeResizeListener = null
    this.removeScrollListener = null
    this.removeMutationsListener = null
    this.removelayoutUpdateListener = null
  }

  get isInDOM() {
    return document.body.contains(this.tooltip)
  }

  create(textContent) {
    this.tooltip = create(textContent)
    this.tooltip.classList.add("is-small", "not_in_print")

    return this
  }

  updateText(textContent) {
    this.tooltip.textContent = textContent

    return this
  }

  append(parent, next) {
    if (this.tooltip == null) {
      next({})
      return
    }

    append(this.tooltip, parent, next)
  }

  remove(next) {
    if (this.tooltip == null) {
      next({})
      return
    }

    remove(this.tooltip, next)
  }

  move(x, y, next) {
    if (this.tooltip == null) {
      next({})
      return
    }

    move(this.tooltip, x, y, next)
  }

  moveTo(el, next) {
    if (this.tooltip == null || !document.body.contains(el)) {
      next({})
      return
    }

    readBoundaries([this.tooltip, el], ([tRect, elRect]) => {
      if (this.tooltip == null || !document.body.contains(el)) {
        next({})
        return
      }

      const relative = getRelativeCoordinates(elRect)
      const shiftedByPage = shiftByPageOffset(relative)
      const shiftedByCenter = shiftByCenter(tRect, elRect, shiftedByPage)
      const { x, y } = shiftUp(tRect, shiftedByCenter)

      addArrowDown(this.tooltip, () => {
        if (this.tooltip == null || !document.body.contains(el)) {
          next({})
          return
        }

        this.move(x, y, next)
      })
    })
  }

  hide() {
    if (this.tooltip == null) return this

    this.tooltip.classList.add("has-opacity-0")
    return this
  }

  show() {
    if (this.tooltip == null) return this

    this.tooltip.classList.remove("has-opacity-0")
    return this
  }

  maybeRemove({ x }) {
    /* the left heading width + el width */
    if (x < 30 && this.isInDOM) this.remove(() => this.removeListeners())
  }

  listenScroll(el) {
    const scrollContainer = getClosestScrollContainer(el)

    if (!scrollContainer) return

    let isRunning = false
    this.removeScrollListener = listenScroll(scrollContainer, () => {
      if (this.tooltip == null) return

      if (!isRunning) {
        isRunning = true
        this.moveTo(el, (err, payload) => {
          this.maybeRemove(payload)
          isRunning = false
        })
      }
    })
  }

  listenMutations(el) {
    let isRunning = false

    this.removeMutationsListener = listenMutations(el, () => {
      if (this.tooltip == null) return

      if (!isRunning) {
        isRunning = true
        this.moveTo(el, () => {
          isRunning = false
        })
      }
    })
  }

  listenResize(el) {
    this.removeResizeListener = listenResize(() => {
      if (this.tooltip == null) return

      this.moveTo(el, () => 1)
    })
  }

  listenLayoutUpdates(el) {
    this.removelayoutUpdateListener = listenLayoutUpdate(() => {
      this.moveTo(el, () => 1)
    })
  }

  removeListeners() {
    this.removeResizeListener()
    this.removeScrollListener()
    this.removeMutationsListener()
    this.removelayoutUpdateListener()
  }
}

export default ExpandTooltip
